import React, { useEffect, useState } from 'react';
import NavBar from "../navigationBar";
import PathDataService from "../services/roomservices";
import './Resources.css';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import MobileNavBar from '../mobileNavigationBar';


function Resources() {
    const [buildingData, setBuildingData] = useState([]);
    const [filterType, setFilterType] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedBuilding, setSelectedBuilding] = useState("Baskin Engineering 1");

    async function automate(buildingName) {
        const RoomsSnapshot = await PathDataService.getAllRooms(buildingName);
        const RoomsData = RoomsSnapshot.docs.map(doc => doc.data());
        const filteredRoomsData = RoomsData.filter(room => !room.room.includes("-"));
        return filteredRoomsData;
    }

    useEffect(() => {
        async function fetchBuildingData() {
            try {
                const buildingData = await automate(selectedBuilding);

                let filteredData = buildingData;

                if (filterType !== "All") {
                    filteredData = filteredData.filter(room => room.information === filterType);
                }

                if (searchQuery) {
                    filteredData = filteredData.filter(room => room.room.startsWith(searchQuery));
                }

                const groupedRooms = {};

                filteredData.forEach(room => {
                    let floor;
                    const roomNumber = parseInt(room.room);

                    if (roomNumber >= 10 && roomNumber < 100) {
                        floor = "Basement";
                    } else {
                        floor = Math.floor(roomNumber / 100).toString();
                    }

                    if (!groupedRooms[floor]) {
                        groupedRooms[floor] = [];
                    }
                    groupedRooms[floor].push(room);
                    // console.log("room = ", roomNumber, "floor = ", floor);
                });

                setBuildingData(groupedRooms);
            } catch (error) {
                console.error("Error fetching building data:", error);
            }
        }

        fetchBuildingData();
    }, [filterType, searchQuery, selectedBuilding]);

    const handleFilterChange = event => {
        setFilterType(event.target.value);
    };

    const handleSearchChange = event => {
        setSearchQuery(event.target.value);
    };

    const handleBuildingChange = event => {
        setSelectedBuilding(event.target.value);
        setSearchQuery("");
    };

    return (
        <>
            <BrowserView>
                <NavBar />
            </BrowserView>
                <h1>Resources</h1>
                <div className="filter-section">
                    <div className="filter-dropdown">
                        <select value={filterType} onChange={handleFilterChange}>
                            <option value="All">All</option>
                            <option value="Classroom">Classroom</option>
                            <option value="Bathroom">Bathroom</option>
                            <option value="Computer Lab">Computer Lab</option>
                            <option value="Study Room">Study Room</option>
                        </select>
                    </div>
                    <div className="building-dropdown">
                        <select value={selectedBuilding} onChange={handleBuildingChange}>
                            <option value="Baskin Engineering 1">Baskin Engineering 1</option>
                            <option value="Baskin Engineering 2">Baskin Engineering 2</option>
                        </select>
                    </div>
                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="Search room..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ width: '100px'}}
                        />
                    </div>
                </div>
                <div className="resources-container">
                    <div className="resources-box">
                        <div className="floor-column">
                            <h3>Floor</h3>
                            {Object.entries(buildingData).map(([floor, rooms]) => (
                                <div key={floor}>
                                    {rooms.map((room, index) => (
                                        <div key={index}>
                                            <span>{floor}</span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className="room-column">
                            <h3>Room</h3>
                            {Object.entries(buildingData).map(([floor, rooms]) => (
                                <div key={floor}>
                                    {rooms.map((room, index) => (
                                        <div key={index}>
                                            <span>{room.room}</span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className="type-column">
                            <h3>Type</h3>
                            {Object.entries(buildingData).map(([floor, rooms]) => (
                                <div key={floor}>
                                    {rooms.map((room, index) => (
                                        <div key={index}>
                                            <span>{room.information}</span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            <MobileView> <MobileNavBar/> </MobileView>
        </>
    );
}

export default Resources;
